<card-component>
	<card-content>
		<performer-classes [performer]="performer"></performer-classes>
	</card-content>
</card-component>
